import Page from "@jumbo/shared/Page";
import OtherGoodsExpenses from "app/pages/Master/ExpenseMaster/OtherGoodsExpenses";
import AddExpenses from "app/pages/Master/ExpenseMaster/OtherGoodsExpenses/AddExpenses";
import AccessMiddleware from "app/routes/middleware/auth/AccessMiddleware";

export const otherGoodsExpenseRoutes = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "expense_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/expense/other-goods",
        element: <Page component={OtherGoodsExpenses} layout={"vertical-default"} />,
      },
      {
        path: "/master/expense/other-goods/add/:invoiceId",
        element: <Page component={AddExpenses} layout={"vertical-default"} />,
      }
    ],
  },
];
